var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.4125 5.0025L9.7025 1.7125C10.0925 1.3225 10.0925 0.6925 9.7025 0.3025C9.3125 -0.0875 8.6825 -0.0875 8.2925 0.3025L5.0025 3.5925L1.7125 0.2925C1.3225 -0.0975 0.6925 -0.0975 0.3025 0.2925C-0.0875 0.6825 -0.0875 1.3125 0.3025 1.7025L3.5925 5.0025L0.2925 8.2925C-0.0975 8.6825 -0.0975 9.3125 0.2925 9.7025C0.4925 9.9025 0.7425 10.0025 1.0025 10.0025C1.2625 10.0025 1.5125 9.9025 1.7125 9.7125L5.0025 6.4125L8.2925 9.7025C8.4925 9.9025 8.7425 10.0025 9.0025 10.0025C9.2625 10.0025 9.5125 9.9025 9.7125 9.7125C10.1025 9.3225 10.1025 8.6925 9.7125 8.3025L6.4125 5.0025Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.1210adf2b1ed69e2ae1525fb5343cd71.svg";
export { ForwardRef as ReactComponent };